import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/section-chef.css";

import { useState } from "react";

import { CircularProgress } from "@mui/material";

import { t } from "../../translations";
import CommunityGuidelines from "./community-guidelines";
import PrivacyPolicy from "./privacy_policy";
import TermsService from "./terms-services";

const SelectTerms = (props) => {
  const { lang } = props;
  const location = useLocation();

  const [load, _] = useState(false);

  let typeOfTerm;

  if (location.pathname === "/privacy-policy") {
    typeOfTerm = t("common.terms_conditions", lang);
  } else if (location.pathname === "/terms-of-service") {
    typeOfTerm = t("common.terms_of_service", lang);
  } else if (location.pathname === "/community-guidelines") {
    typeOfTerm = t("common.community_guidelines", lang);
  }

  useEffect(() => {}, []);

  return (
    <div
    // className="section-chef-menu-right-profil"
    >
      <div className="section-chef-menu-right-profil-inside">
        {load && <CircularProgress size={40} />}
        <div
          className="section-chef-menu-right-profil-inside-box"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: 50
          }}
        >
          <p
            style={{
              fontSize: "1.8rem",
              textAlign: "center"
            }}
          >
            {typeOfTerm}
          </p>

          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <div style={{ maxWidth: "2800px", display: "flex" }}>
              {" "}
              {/*utilisation du maxwidth pour eviter des comportements inattendu avec les tailles des differents éléments (img, div etc) */}
              {location.pathname === "/privacy-policy" && (
                <PrivacyPolicy lang={lang} />
              )}
              {location.pathname === "/terms-of-service" && (
                <TermsService lang={lang} />
              )}
              {location.pathname === "/community-guidelines" && (
                <CommunityGuidelines lang={lang} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTerms;
